import React, { Component } from "react";
import axios from "axios";
import { message, Select } from "antd";
import {
  ModalItem,
  Form,
  FormItem,
  InputItem,
  SelectItem,
  ButtonItem,
  HeaderItem,
  BoxItem,
  TextAreaItem,
  SwitchItem,
} from "../../../../Components/Items";

const { Option } = Select;

class ModalCategoria extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    principalesDisponibles: [],
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      this.cargarPrincipales();
      if (this.props.modo === "editar" && this.props.categoriaId) {
        this.consultarCategoria(this.props.categoriaId);
      } else {
        setTimeout(() => {
          if (this.formRef.current) {
            this.formRef.current.resetFields();
            this.formRef.current.setFieldsValue({
              esPrincipal: false,
              categoriaPadreId: this.props.categoriaPadrePreseleccionada || null,
              familiaIds: this.props.familiaPreseleccionada
                ? [this.props.familiaPreseleccionada]
                : [],
            });
          }
        }, 0);
      }
    }
  }

  cargarPrincipales = async () => {
    try {
      const res = await axios.post(
        "categoriasInsumo/selectTodasCategoriasInsumo",
        {
          empresaId: this.props.empresaId,
          valor: 1,
          soloPrincipales: true,
        },
        { headers: this.props.headersToken }
      );
      if (res.data && res.data.success === 2) {
        this.setState({ principalesDisponibles: res.data.categorias || [] });
      }
    } catch (err) {
      console.error("Error cargando principales:", err);
    }
  };

  consultarCategoria = async (id) => {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "categoriasInsumo/obtenerCategoriaInsumoPorId",
        { categoriaInsumoId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2 && res.data.categoria) {
        const cat = res.data.categoria;
        this.formRef.current.setFieldsValue({
          nombre: cat.nombre,
          descripcion: cat.descripcion || "",
          tipoDato: cat.tipoDato,
          esPrincipal: !!cat.esPrincipal,
          categoriaPadreId: cat.categoriaPadreId || null,
          familiaIds: cat.familiaIds || [],
        });
      } else {
        message.error(res.data.message || "No se pudo cargar la categoría");
      }
    } catch (err) {
      console.error(err);
      message.error("Error al consultar categoría");
    } finally {
      this.setState({ loading: false });
    }
  };

  atras = () => {
    if (this.formRef.current) this.formRef.current.resetFields();
    if (this.props.onClose) this.props.onClose();
  };

  onFinish = (values) => {
    this.setState({ loading: true });
    const esEditar = this.props.modo === "editar";
    const endpoint = esEditar
      ? "categoriasInsumo/editarCategoriaInsumo"
      : "categoriasInsumo/agregarCategoriaInsumo";

    const esPrincipal = !!values.esPrincipal;
    const payload = {
      empresaId: this.props.empresaId,
      nombre: values.nombre,
      descripcion: values.descripcion || "",
      esPrincipal,
      categoriaPadreId: esPrincipal ? null : values.categoriaPadreId || null,
      tipoDato: esPrincipal ? undefined : values.tipoDato,
      familiaIds: values.familiaIds || [],
    };
    if (esEditar) payload.categoriaInsumoId = this.props.categoriaId;

    axios
      .post(endpoint, payload, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            esEditar ? "Categoría actualizada" : "Categoría creada"
          );
          if (this.formRef.current) this.formRef.current.resetFields();
          if (this.props.onClose) this.props.onClose();
        } else {
          message.error(res.data.message || "No se pudo guardar la categoría");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al guardar la categoría");
      });
  };

  render() {
    const titulo =
      this.props.modo === "editar" ? "Editar categoría" : "Agregar categoría";
    const esEditar = this.props.modo === "editar";

    return (
      <ModalItem
        title={titulo}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.atras}
        paddingTop
        width={600}
      >
        <Form
          ref={this.formRef}
          name="categoriaInsumo"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish}
        >
          <HeaderItem>DATOS DE LA CATEGORÍA</HeaderItem>
          <BoxItem>
            <FormItem label="Nombre" name="nombre" required margin>
              <InputItem placeholder="Ej. Voltaje, Color, Material" />
            </FormItem>
            <FormItem
              label="Descripción"
              name="descripcion"
              margin
              tooltip="Esta descripción aparecerá como tooltip al asignar valores en los insumos"
            >
              <TextAreaItem
                placeholder="Descripción de la categoría (qué representa, cómo usarla)"
                rows={2}
              />
            </FormItem>

            <FormItem
              label="Categoría principal"
              name="esPrincipal"
              valuePropName="checked"
              margin
              tooltip={
                esEditar
                  ? "Este atributo no se puede cambiar después de crear la categoría"
                  : "Las categorías principales agrupan otras categorías y NO tienen valores propios. Se usan para organizar filtros (ej. 'Componentes pasivos')."
              }
              initialValue={false}
            >
              <SwitchItem disabled={esEditar} />
            </FormItem>

            <FormItem noStyle shouldUpdate={(prev, curr) => prev.esPrincipal !== curr.esPrincipal}>
              {({ getFieldValue }) => {
                const esPrincipalActual = !!getFieldValue("esPrincipal");
                if (esPrincipalActual) return null;
                return (
                  <>
                    <FormItem
                      label="Pertenece a (padre)"
                      name="categoriaPadreId"
                      margin
                      tooltip="Selecciona una categoría principal bajo la cual agrupar esta. Dejar vacío para que sea categoría suelta."
                    >
                      <SelectItem
                        placeholder="Sin agrupar (categoría suelta)"
                        allowClear
                      >
                        {this.state.principalesDisponibles.map((p) => (
                          <Option key={p._id} value={p._id}>
                            {p.nombre}
                          </Option>
                        ))}
                      </SelectItem>
                    </FormItem>
                    <FormItem
                      label="Tipo de dato"
                      name="tipoDato"
                      required
                      margin
                      tooltip={
                        esEditar
                          ? "No se puede cambiar el tipo de dato una vez creada la categoría"
                          : "Define el tipo de valor que tomará esta categoría"
                      }
                    >
                      <SelectItem
                        placeholder="Seleccionar tipo"
                        disabled={esEditar}
                      >
                        <Option value="texto">Texto</Option>
                        <Option value="numero">Número</Option>
                        <Option value="fecha">Fecha</Option>
                        <Option value="booleano">Booleano</Option>
                      </SelectItem>
                    </FormItem>
                  </>
                );
              }}
            </FormItem>

            <FormItem
              label="Aplica a familias"
              name="familiaIds"
              margin
              tooltip="Dejar vacío para que aplique a todas las familias"
            >
              <SelectItem
                mode="multiple"
                placeholder="Todas las familias"
                allowClear
              >
                {(this.props.todasFamilias || []).map((f) => (
                  <Option key={f._id} value={f._id}>
                    {f.nombre}
                  </Option>
                ))}
              </SelectItem>
            </FormItem>
          </BoxItem>
        </Form>
      </ModalItem>
    );
  }
}

export default ModalCategoria;
